var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 12.5007V10.1673H19.3332V12.5007H0.666504ZM0.666504 17.1673V14.834H19.3332V17.1673H0.666504ZM0.666504 7.83398V5.50065H19.3332V7.83398H0.666504ZM0.666504 3.16732V0.833984H19.3332V3.16732H0.666504Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadline);
export default __webpack_public_path__ + "static/media/icon_headline.6098b5e83997a955c302f11e1a4d21bb.svg";
export { ForwardRef as ReactComponent };